<template>
  <v-container class="mt-4" fluid>
    <v-card class="pa-4">
      <header>
        <h4>{{$_strings.statusOrder.STATUS_HISTORY}}</h4>
      </header>
      <v-card elevation="1" class="mt-5 card__rounded">
        <v-row justify="center" class="mb-5">
          <v-col class="d-flex align-center" cols="1">
            <!-- <v-divider class="custom__divider"></v-divider> -->
          </v-col>
          <v-col cols="auto">
            <div class="wrapper__icon">
              <v-img
                src="@/assets/images/pickup-icon.png"
                v-bind:style="isDelivery ? null : grayscale"
              />
              <img
                v-if="isDelivery"
                src="@/assets/images/icon-checkmark-green.png"
                class="checkmarkIcon"
              />
            </div>
          </v-col>
          <v-col class="d-none d-sm-flex align-center">
            <div class="custom_divider">
              <p class="mb-0">{{pickupDuration}}</p>
            </div>
          </v-col>
          <v-col cols="auto">
            <div class="wrapper__icon">
              <img
                src="@/assets/images/truck-icon.png"
                v-bind:style="isUnload ? null : grayscale"
              />
              <img
                v-if="isUnload"
                src="@/assets/images/icon-checkmark-green.png"
                class="checkmarkIcon"
              />
            </div>
          </v-col>
          <v-col class="d-none d-sm-flex align-center">
            <div class="custom_divider">
              <p class="mb-0">{{deliveryDuration}}</p>
            </div>
          </v-col>
          <v-col cols="auto">
            <div class="wrapper__icon">
              <img
                src="@/assets/images/warehouse-icon.png"
                v-bind:style="isCompleted ? null : grayscale"
              />
              <img
                v-if="isCompleted"
                src="@/assets/images/icon-checkmark-green.png"
                class="checkmarkIcon"
              />
            </div>
          </v-col>
          <v-col class="d-flex align-center" cols="1">
            <!-- <v-divider class="custom__divider"></v-divider> -->
          </v-col>
        </v-row>
      </v-card>
      <v-row class="pa-4">
        <v-col class="pb-0" cols="12">
          <span>{{$_strings.statusOrder.STATUS_ORDER}}</span>
        </v-col>
        <v-col v-for="(status, index) in historyStatus" :key="index"  cols="12">
          <section class="d-flex">
            <div>
              <p class="grey--text pb-0 mb-0">{{dateFormat(status.statusDateTime)}}</p>
              <p class="mt-0 pt-0 mb-0">{{status.status}}</p>
              <p class="grey--text">{{status.notes}}</p>
            </div>
            <v-spacer></v-spacer>
            <div class="d-flex align-center">
              <p class="pa-0 ma-0">{{timeFormat(status.statusDateTime)}}</p>
            </div>
          </section>
          <v-divider class="mt-5"></v-divider>
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-col cols="auto">
          <v-btn
            outlined
            color="primary"
            @click="$router.go(-1)"
          >
            {{$_strings.common.BACK}}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import dayjs from 'dayjs';
import { dateFormat, timeFormat, dateDiff } from '../../helper/commonHelpers';

export default {
  data() {
    return {
      grayscale: {
        filter: 'grayscale(100%)',
      },
      historyStatus: [],
    };
  },
  mounted() {
    const { params: { id } } = this.$route;
    this.fetchData(id);
  },
  computed: {
    isDelivery() {
      return this.historyStatus.filter((status) => status.status.toLowerCase() === 'pengiriman').length;
    },
    isUnload() {
      return this.historyStatus.filter((status) => status.status.toLowerCase() === 'di lokasi tujuan').length;
    },
    isCompleted() {
      return this.historyStatus.filter((status) => status.status.toLowerCase().includes('diterima')).length;
    },
    pickupDuration() {
      const pickupStatus = this.historyStatus.find(
        (i) => i.status.toLowerCase() === 'penjemputan',
      );
      const deliverStatus = this.historyStatus.find(
        (i) => i.status.toLowerCase() === 'pengiriman',
      );
      const pickupTime = pickupStatus ? dayjs(pickupStatus.statusDateTime).diff() : null;
      const deliverTime = deliverStatus ? dayjs(deliverStatus.statusDateTime).diff() : null;
      if (!pickupTime || !deliverTime) return '';
      const milliseconds = dayjs(deliverStatus.statusDateTime).diff(pickupStatus.statusDateTime);
      return dateDiff((pickupTime - deliverTime) / 1000) || `${dayjs(milliseconds).format('s')} Detik`;
    },
    deliveryDuration() {
      const deliverStatus = this.historyStatus.find(
        (i) => i.status.toLowerCase() === 'pengiriman',
      );
      const completeStatus = this.historyStatus.find(
        (i) => i.status.toLowerCase().includes('diterima')
          || i.status.toLowerCase().includes('ditolak'),
      );
      const deliverTime = deliverStatus ? dayjs(deliverStatus.statusDateTime).diff() : null;
      const completeTime = completeStatus ? dayjs(completeStatus.statusDateTime).diff() : null;
      if (!deliverTime || !completeTime) return '';
      const milliseconds = dayjs(deliverTime.statusDateTime).diff(completeTime.statusDateTime);
      return dateDiff((deliverTime - completeTime) / 1000) || `${dayjs(milliseconds).format('s')} Detik`;
    },
  },
  methods: {
    dateFormat,
    timeFormat,
    fetchData(orderId) {
      this.$root.$loading.show();
      this.$_services.order.getHistoryStatus(orderId)
        .then((res) => {
          const lastLocation = res.data.find((loc) => loc.status === 'Di Lokasi Tujuan');
          let lastLocDestName = '';
          if (lastLocation) lastLocDestName = lastLocation.notes;
          this.historyStatus = res.data.map((data) => {
            if (data.status === 'BA Penerimaan - Diterima Gudang') {
              return {
                ...data,
                notes: lastLocDestName,
              };
            }
            return { ...data };
          });
        }).finally(() => {
          this.$root.$loading.hide();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
hr::v-deep.custom__divider.v-divider.theme--light {
  border-style: dashed;
  // color: red;
}
.card__rounded {
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.04) !important;
  border-radius: 50px;
}
.wrapper__icon {
  position: relative;
  .checkmarkIcon {
    position: absolute;
    right: 5px;
    top: 5px;
  }
}
.custom_divider {
  width: 100%;
  height: 25px;
  margin-bottom: 20px;
  border-bottom: 1px dashed #707070;
  display: flex;
  justify-content: center;
}
</style>
